@if (errorCode === HTTP_ERRORS.PageNotFound) {
  <app-error-404></app-error-404>
}

@if (errorCode === HTTP_ERRORS.somethingWentWrong) {

  <div class="wrapper">
    <div [class.width600]="errorCode === HTTP_ERRORS.somethingWentWrong" class="wrapper-content">
      <div class="main">
        <p class="text-center" style="margin-bottom: 40px">
          <img alt="page not found" height="113" ngSrc="assets/images/ops-image.svg" width="84">
        </p>

        <div class="title text-center">{{ 'Oops! Something went wrong' |translate }}.</div>
        <div class="main-text">
          <p
            class="text-center">{{ 'We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for.' | translate }}</p>
        </div>
        <div class="footer" style="display: flex; justify-content: center">
          <app-button [ariaLabel]=" 'Back home'|translate" (clicked)="goHome()" [buttonStyleType]="BUTTON_TYPES.PRIMARY_0">{{ 'Back home'|translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
}
